module.exports = __webpack_public_path__ + "img/receipt-blue.e37ca904.svg";